import type { ReactNode } from 'react';

export interface AbaSublinhado<K extends string = string> {
  key: K;
  label: string;
  icon?: ReactNode;
}

interface AbasSublinhadoProps<K extends string> {
  abas: AbaSublinhado<K>[];
  ativa: K;
  onChange: (key: K) => void;
  className?: string;
}

/** Abas Íris com indicador de sublinhado 2px accent. */
export default function AbasSublinhado<K extends string>({ abas, ativa, onChange, className = '' }: AbasSublinhadoProps<K>) {
  return (
    <div role="tablist" className={`flex gap-1 border-b border-line ${className}`}>
      {abas.map((aba) => (
        <button
          key={aba.key}
          type="button"
          role="tab"
          aria-selected={ativa === aba.key}
          onClick={() => onChange(aba.key)}
          className={`flex items-center gap-1.5 px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors ${
            ativa === aba.key
              ? 'border-accent text-accent-text'
              : 'border-transparent text-tx-2 hover:text-tx'
          }`}
        >
          {aba.icon}
          {aba.label}
        </button>
      ))}
    </div>
  );
}
